module.exports = __webpack_public_path__ + "img/Path.afa39d9e.svg";